import { isValid, parse, format } from 'date-fns';

export function isValidDate(date: string): boolean {
  const parsedDate = parse(date, 'yyyy-MM-dd', new Date());
  return isValid(parsedDate) && parsedDate <= new Date();
}

export function formatDate(date: Date): string {
  return format(date, 'yyyy-MM-dd');
}

export function formatDateTime(date: Date): string {
  return format(date, 'dd/MM/yyyy HH:mm');
}

export function formatTime(date: Date): string {
  return format(date, 'HH:mm');
}
